import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { stringify } from "qs";

import { getWarehouseServiceUrl } from "~/api/warehouse";
import { customClientBApiRoutePath } from "~/config/customClientBConfig";
import {
  accessTokenFactory,
  setUnauthorizedLogoutRequested
} from "~/features/login/login.slice";
import { StoreState } from "~/redux/reducers";
import { selectSiteNameHeader } from "~/redux/selectors/storeSelectors";

export const customClientBApiBase = fetchBaseQuery({
  baseUrl: `${getWarehouseServiceUrl()}/${customClientBApiRoutePath}/api`,
  prepareHeaders: async (headers, api) => {
    const state = api.getState() as StoreState;
    const accessToken = await accessTokenFactory(
      state.login.accessToken,
      state.login.authMethod
    );
    headers.set("authorization", `Bearer ${accessToken}`);
    headers.set("SiteName", selectSiteNameHeader(state));
  },
  paramsSerializer: (params) => stringify(params, { arrayFormat: "repeat" })
});

export const customClientBApiBaseWithRedirectOn401: typeof customClientBApiBase =
  async (args, api, extraOptions) => {
    const result = await customClientBApiBase(args, api, extraOptions);
    if (
      result.error &&
      result.error.status === 401 &&
      !result.meta?.request?.url.includes(
        `/${customClientBApiRoutePath}/api/v1/user/login`
      ) &&
      !window.location.href.includes("/logout") &&
      !window.location.href.includes("/login")
    ) {
      api.dispatch(setUnauthorizedLogoutRequested(true));
    }
    return result;
  };

export const customClientBApi = createApi({
  baseQuery: customClientBApiBaseWithRedirectOn401,
  endpoints: () => ({}),
  reducerPath: "customClientBApi"
});
